import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, Card, CardBody, CardFooter, Col, Container, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import municipioService from "services/MunicipioService";
import CustomPagination from "components/CustomPagination";
import IconButton from "components/IconButton";
import estadoService from "services/EstadoService";

export default function Municipios() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [estados, setEstados] = useState([])

  const [termo, setTermo] = useState(null)
  const [uf, setUf] = useState(null)

  const [items, setItems] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setEstados(estadoService.get())
  }, [])

  const carregar = async () => {
    const res = await municipioService.get(termo, uf, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await municipioService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Munícipio excluído")
          } else {
            toast("Erro ao excluir o município")
          }
        } catch (ex) {
          toast("Erro ao excluir o município")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Municípios</h1>
          <Link className="btn btn-primary btn-icon" to="/admin/municipios/0">Incluir</Link>
        </div>
        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Nome</Label>
                    <Input type="text" placeholder="Nome" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Estado</Label>
                    <select className="form-control" value={uf || ''} onChange={e => setUf(e.target.value)}>
                      <option value="">Todos</option>
                      {estados.map(el => (
                        <option key={el.sigla} value={el.sigla}>{el.nome}</option>
                      ))}
                    </select>
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">UF</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={4} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.nome}</td>
                  <td>{el.uf}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/municipios/" + el.id)} />
                    <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}